module.exports = __webpack_public_path__ + "img/violet_084.cb4bbb4c.png";